// API configuration for single-domain deployment
// All API calls use relative paths since frontend and backend are on the same domain

// Check if we're in local development
const isLocalDev = process.env.REACT_APP_ENVIRONMENT === 'development';

// In local development, use the backend URL from environment or default to localhost:3001
// In production, use relative paths (empty string)
export const API_BASE_URL = isLocalDev 
  ? (process.env.REACT_APP_API_URL || 'http://localhost:3001')
  : '';

export const API_ENDPOINTS = {
  // Chat endpoints
  CHAT: '/api/chat',
  CHAT_MESSAGE: '/api/chat/message',
  CHAT_SESSION: '/api/chat/session',
  CHAT_SESSIONS: '/api/chat/sessions',
  CHAT_SESSION_BY_ID: (sessionId: string) => `/api/chat/session/${sessionId}`,
  CHAT_HISTORY: (sessionId: string) => `/api/chat/history/${sessionId}`,
  
  // Auth endpoints - Note: login/logout are at root level, not under /api
  AUTH_LOGIN: '/login',  // Server-side OIDC login
  AUTH_LOGOUT: '/logout',  // Server-side OIDC logout
  AUTH_CALLBACK: '/auth/callback',  // OAuth callback
  AUTH_STATUS: '/api/auth/status',  // Check auth status
  AUTH_ME: '/api/auth/me',  // Get current user
  AUTH_PROFILE: '/api/auth/profile',
  
  // Cognito SDK endpoints (if using direct SDK integration)
  AUTH_REGISTER: '/api/auth/register',
  AUTH_CONFIRM: '/api/auth/confirm',
  AUTH_REFRESH: '/api/auth/refresh',
  AUTH_FORGOT_PASSWORD: '/api/auth/forgot-password',
  AUTH_RESET_PASSWORD: '/api/auth/reset-password',
  AUTH_CHANGE_PASSWORD: '/api/auth/change-password',
  AUTH_RESEND_CONFIRMATION: '/api/auth/resend-confirmation',
  
  // User endpoints
  USER_PREFERENCES: '/api/user/preferences',
  USER_SETTINGS: '/api/user/settings',
  
  // Admin endpoints
  ADMIN_USERS: '/api/admin/users',
  ADMIN_USER_BY_ID: (userId: string) => `/api/admin/users/${userId}`,
  ADMIN_ANALYTICS: '/api/admin/analytics',
  ADMIN_SETTINGS: '/api/admin/settings',
  
  // Health endpoint
  HEALTH: '/api/health',
  
  // File endpoints
  FILE_UPLOAD: '/api/files/upload',
  FILE_UPLOAD_URL: '/api/files/upload-url',
  FILE_DELETE: (fileId: string) => `/api/files/${fileId}`,
  FILE_LIST: '/api/files',
};

// Build URL function - adds base URL for local development
export const buildURL = (endpoint: string): string => {
  // In local development, prepend the API base URL
  if (API_BASE_URL) {
    return `${API_BASE_URL}${endpoint}`;
  }
  // In production, just return the endpoint (relative path)
  return endpoint;
};

export default {
  API_BASE_URL,
  API_ENDPOINTS,
  buildURL,
};
